import { render } from "./GlobalContent.vue?vue&type=template&id=815617f6&scoped=true&ts=true"
import script from "./GlobalContent.vue?vue&type=script&lang=ts"
export * from "./GlobalContent.vue?vue&type=script&lang=ts"

import "./GlobalContent.vue?vue&type=style&index=0&id=815617f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815617f6"]])

export default __exports__